import { render, staticRenderFns } from "./CircleProgress.vue?vue&type=template&id=0cfb057e"
import script from "./CircleProgress.vue?vue&type=script&lang=js"
export * from "./CircleProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports